module.exports = __webpack_public_path__ + "static/media/logoatend.16369fb9.png";